import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const RadioList = ({ name, options, label, line, onChange, title, value, disabled, required }) => (
  <div className={classnames('ncss-form-group', { required: required })}>
    {label ? (
      <div title={title} htmlFor={title} className='radioList__label mt2-sm d-sm-b'>
        {label}
      </div>
    ) : null}
    <div className={line ? 'ncss-toggle-line' : 'radioList'}>
      {options && options.length && (
        <ul>
          {options.map(option => (
            <li key={option.value} className='pb2-sm'>
              <input
                className='ncss-radio'
                type='radio'
                name={`${name}-${option.value}`}
                id={`${name}-${option.value}`}
                data-desc={`${name}_radioList_${value}`}
                onChange={() => onChange(option)}
                checked={option.value === value ? 'checked' : false}
                disabled={disabled}
              />
              <label className='radioList__label pr5-sm pl2-sm' htmlFor={`${name}-${option.value}`}>
                {option.label}
              </label>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

RadioList.defaultProps = {
  options: [],
  line: false,
  disabled: false,
  required: false,
  value: null,
  title: null
};

RadioList.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  label: PropTypes.any.isRequired,
  line: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  value: PropTypes.string
};

export default RadioList;
